import { render, staticRenderFns } from "./eligible-campaigns-card.vue?vue&type=template&id=2f163f5d&scoped=true&"
import script from "./eligible-campaigns-card.vue?vue&type=script&lang=js&"
export * from "./eligible-campaigns-card.vue?vue&type=script&lang=js&"
import style0 from "./eligible-campaigns-card.vue?vue&type=style&index=0&id=2f163f5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f163f5d",
  null
  
)

export default component.exports